import React, { useState } from 'react'
import { usePage } from '@inertiajs/react'

import { Input } from '@material-tailwind/react'
import { FaRegEye, FaEyeSlash } from 'react-icons/fa6'
import Select from 'react-tailwindcss-select'

import LoadingButton from '@/Shared/LoadingButton'
import DeleteButton from '@/Shared/DeleteButton'

export default function({ data, errors, processing, setData, handleSubmit, isEdit, deleted_at, destroy }) {
    const {
        hospitals, auth: {
            user: { role }
        }
    } = usePage().props

    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    return (
        <form name="createForm" onSubmit={handleSubmit} className="mt-8">
            <div className="flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Name"
                    name="name"
                    error={errors.name}
                    value={data.name}
                    onChange={e => setData('name', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Email"
                    name="email"
                    error={errors.email}
                    value={data.email}
                    onChange={e => setData('email', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    label="Password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    icon={
                        showPassword ? (
                            <FaEyeSlash onClick={() => setShowPassword(false)} />
                        ) : (
                            <FaRegEye onClick={() => setShowPassword(true)} />
                        )
                    }
                    error={errors.password}
                    value={data.password}
                    onChange={e => setData('password', e.target.value)}
                />

                <Input
                    label="Confirm Password"
                    name="confirmation_password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    icon={
                        showConfirmPassword ? (
                            <FaEyeSlash onClick={() => setShowConfirmPassword(false)} />
                        ) : (
                            <FaRegEye onClick={() => setShowConfirmPassword(true)} />
                        )
                    }
                    error={errors.password_confirmation}
                    value={data.password_confirmation}
                    onChange={e => setData('password_confirmation', e.target.value)}
                />
            </div>

            {role === '1' && (
                <div className="mt-6 flex flex-col gap-4 md:flex-row">
                    <Select
                        label="Role"
                        name="role"
                        primaryColor="indigo"
                        options={[
                            { value: '1', label: 'Super Admin' },
                            { value: '0', label: 'Admin' }
                        ]}
                        value={{
                            value: data.role,
                            label: data.role === '0' ? 'Admin' : 'Super Admin'
                        }}
                        onChange={option => setData('role', option.value)}
                    />

                    {data.role === '0' && (
                        <Select
                            label="Select Hospital"
                            name="role"
                            error={errors.hospital_id}
                            primaryColor="indigo"
                            value={
                                data.hospital_id && {
                                    value: data.hospital_id,
                                    label: hospitals.find(
                                        hospital => hospital.id === data.hospital_id
                                    ).name
                                }
                            }
                            isSearchable
                            options={hospitals.map(hospital => ({
                                label: hospital.name,
                                value: hospital.id
                            }))}
                            onChange={option => setData('hospital_id', option.value)}
                        />
                    )}
                </div>
            )}

            <div className="mt-8 flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4">
                {isEdit && !deleted_at && role === '1' && (
                    <DeleteButton onDelete={destroy}>Delete User</DeleteButton>
                )}

                <LoadingButton
                    loading={processing}
                    type="submit"
                    className="btn-indigo"
                >
                    {isEdit ? 'Update User' : 'Create User'}
                </LoadingButton>
            </div>
        </form>
    )
}
